<template>
  <form class="flex mt-4" @submit.prevent="logout">
    <button
      class="flex self-end items-center w-full justify-center w-[170px] px-4 py-3 mt-4 group text-[16px] hover:opacity-80 text-brand-green font-mono bg-brand-gray-900 border border-brand-green hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700 hover:cursor-pointer"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-3">
        <path d="M3.33333 14.0039C2.96667 14.0039 2.65278 13.8734 2.39167 13.6122C2.13056 13.3511 2 13.0372 2 12.6706V3.33724C2 2.97057 2.13056 2.65668 2.39167 2.39557C2.65278 2.13446 2.96667 2.00391 3.33333 2.00391H8V3.33724H3.33333V12.6706H8V14.0039H3.33333ZM10.6667 11.3372L9.75 10.3706L11.45 8.67057H6V7.33724H11.45L9.75 5.63724L10.6667 4.67057L14 8.00391L10.6667 11.3372Z" fill="#9EFC4E"/>
      </svg>
      Odhlásit se
    </button>
  </form>
</template>

<script>
export default {

    setup() {
        const logout = async () => {

        try {
            const res = await axios.post(route("user.logout"), {}, {
            headers: {
                'Accept': 'application/json'
            }
            });

            if(res.status === 200) {
            window.location.href = route("frontend.homepage");
            }
        } catch(err) {}
        }

        return {
            logout
        }
    }
}
</script>

<style>

</style>
